module.exports = __webpack_public_path__ + "media/categories/1086-82a51c63.svg";